type Props = {
  job: {
    packages: {
      indexUrl: string;
    };
  };
};

function Skeleton() {
  return (
    <div className="border-gray mt-0 flex items-center bg-gray-100 px-4 py-3">
      <div className="flex w-full flex-row gap-2">
        <span className="semi-bold inline-flex grow items-center gap-2 py-3">
          <div className="aspect-square h-4 w-4 animate-pulse rounded bg-gray-400" />
          <div className="h-2 w-40 animate-pulse rounded bg-gray-400" />
        </span>
      </div>
    </div>
  );
}

export default function Packages({ job }: Props) {
  return (
    <div className="p-4">
      <turbo-frame id="job_packages" src={job.packages.indexUrl}>
        <div className="flex flex-col gap-2">
          <Skeleton />
        </div>
      </turbo-frame>
    </div>
  );
}
